var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.doc",
  title: "Control Preview: Rich Text",
  description: "Read-only preview renderer for ua.doc.simple (UA/JSON rich text) values: shows the readable text, one line per block.",
  fields: {
    "value": { title: "Value", type: "*", description: "UA/JSON document (object or JSON string) or plain text." }
  }
});

var helper = require("./helpers/control.preview.js");

var BLOCKS = ["p", "div", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "pre"];

function parse(value) {
  if (typeof value !== "string") return value;
  var txt = value.trim();
  if (txt.charAt(0) !== "{" && txt.charAt(0) !== "[") return value;
  try { return JSON.parse(txt); } catch (error) { return value; }
}

/* Flatten a UA/JSON node to text. Block nodes become their own lines; list
 * items get a bullet. Inline nodes (b, i, u, a, span…) contribute their text. */
function collect(node, lines, current, inList) {
  if (node === null || node === undefined) return current;
  if (typeof node === "string" || typeof node === "number") {
    return current + String(node);
  }
  if (node instanceof Array) {
    for (var i = 0; i < node.length; i++) current = collect(node[i], lines, current, inList);
    return current;
  }
  if (typeof node !== "object") return current;

  var ns = (node.namespace || node.n || "").toString().toLowerCase();
  var inner = node.inner !== undefined ? node.inner : node.i;
  if (ns === "br") return current + "\n";

  var isBlock = BLOCKS.indexOf(ns) >= 0;
  if (!isBlock) return collect(inner, lines, current, inList || ns === "ul" || ns === "ol");

  if (current.trim()) lines.push(current.trim());
  var text = collect(inner, lines, "", inList).trim();
  if (text) lines.push((ns === "li" ? "• " : "") + text);
  return "";
}

function toLines(rawValue) {
  var value = parse(rawValue);
  var lines = [];
  if (typeof value === "string") {
    lines = value.split(/\n+/g);
  } else {
    var tail = collect(value, lines, "", false);
    if (tail.trim()) lines.push(tail.trim());
  }
  return lines.map(function(line) { return (line || "").toString().trim(); }).filter(Boolean);
}

exports.render = async function(options) {
  return helper.renderDoc(helper.jsonLines(toLines(options.value), "ua-control-preview-lines"));
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function(options) {
  return toLines((options || {}).value).join("\n");
};
